import { render, staticRenderFns } from "./cReportsHolder.vue?vue&type=template&id=b1629982"
import script from "./cReportsHolder.vue?vue&type=script&lang=js"
export * from "./cReportsHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports